import React from "react";
import moment from "moment"
import CalendarDateRange from "storybookComponents/CalendarDateRange"
import { getPreviousMonday, addDays } from "../CalendarUtils"

export default ({
  date,
  goToday,
  goPrev,
  goNext,
}) => {
  return (
    <CalendarDateRange
      startDate={moment(getPreviousMonday(new Date(date))).format(
        "DD MMM YYYY"
      )}
      endDate={moment(
        addDays(new Date(getPreviousMonday(new Date(date))), 27)
      ).format("DD MMM YYYY")}
      onTodayClick={goToday}
      onPrevClick={goPrev}
      onNextClick={goNext}
    />
  );
};
